import { createContext } from "react";

const RefreshShiftLogsContext = createContext(null);
export { RefreshShiftLogsContext };
